import { getElementClientRect } from '../helpers'
import { TConfigs } from '../types'

interface IProps {
    scrollableParents: Set<HTMLElement | Window>
    reference: HTMLElement
    popupConfigs?: TConfigs
}

export default function hide({ scrollableParents, reference, popupConfigs }: IProps) {
    const { detectHidden = false } = popupConfigs || {}
    /*
     * Return immediately if not enable detect hidden
     * */
    if (!detectHidden) {
        return false
    }
    let isHidden = false
    /*
     * Reference values
     * */
    const referenceRect = reference.getBoundingClientRect()
    const referenceLeft = referenceRect.left
    const referenceRight = referenceRect.right
    const referenceTop = referenceRect.top
    const referenceBottom = referenceRect.bottom

    const scrollableParentsLength = scrollableParents.size
    const arrayScrollableParents = Array.from(scrollableParents)

    for (let i = 0; i < scrollableParentsLength; ++i) {
        const parentRect = getElementClientRect(arrayScrollableParents[i])
        const parentLeft = parentRect.left
        const parentRight = parentRect.right
        const parentTop = parentRect.top
        const parentBottom = parentRect.bottom
        isHidden =
            referenceRight < parentLeft ||
            referenceLeft > parentRight ||
            referenceBottom < parentTop ||
            referenceTop > parentBottom
        if (isHidden) {
            break
        }
    }
    return isHidden
}
